<div class="customer-page">
  <h2>Create Customer</h2>

  <form [formGroup]="customerForm" class="form-container">
    <mat-form-field class="full-width">
      <mat-label>Customer Name</mat-label>
      <input matInput formControlName="customerName" />
    </mat-form-field>

    <div class="gender-group">
      <label class="gender-label">Gender</label>
      <mat-radio-group formControlName="gender" class="gender-radio">
        <mat-radio-button value="Male">Male</mat-radio-button>
        <mat-radio-button value="Female">Female</mat-radio-button>
      </mat-radio-group>
    </div>

    <mat-form-field class="full-width">
      <mat-label>Phone Number</mat-label>
      <input matInput type="tel" formControlName="phoneNumber" />
    </mat-form-field>

     <mat-form-field class="full-width">
      <mat-label>Customer Email</mat-label>
      <input matInput formControlName="email" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Door No</mat-label>
      <input matInput formControlName="doorNo" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Area</mat-label>
      <input matInput formControlName="area" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Pin Code</mat-label>
      <input matInput type="number" formControlName="pinCode" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>City</mat-label>
      <input matInput formControlName="city" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>State</mat-label>
      <input matInput formControlName="state" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Date of Birth</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="dob" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Plan</mat-label>
      <mat-select
        formControlName="plan"
        (selectionChange)="onPlanChange($event.value)"
      >
        <mat-option *ngFor="let plan of chitPlans" [value]="plan.id">
          {{ plan.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <h3 *ngIf="customerForm.get('plan')?.value">
      {{ "Min.Amount - " + minAmount  }}
    </h3>

    <div *ngIf="benefitPoints.length > 0">
      <h4>Benefits:</h4>
      <ul>
        <li *ngFor="let b of benefitPoints">{{ b }}</li>
      </ul>
    </div>

    <!-- Description -->
    <div *ngIf="descriptionPoints.length > 0">
      <h4>Description:</h4>
      <ul>
        <li *ngFor="let d of descriptionPoints">{{ d }}</li>
      </ul>
    </div>

     <mat-form-field class="full-width" *ngIf="customerForm.get('plan')?.value">
      <mat-label>Due Range</mat-label>
      <mat-select
        formControlName="dueType"
      >
        <mat-option *ngFor="let range of dueRangeOptions" [value]="range">
          {{ range }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width" *ngIf="customerForm.get('plan')?.value">
      <mat-label>Amount per month</mat-label>
      <input matInput formControlName="amount" />
      <mat-error *ngIf="customerForm.get('amount')?.hasError('outOfRange')">
        Minimum - {{ minAmount }}
      </mat-error>
      <mat-error
        *ngIf="customerForm.get('amount')?.hasError('invalidIncrement')"
      >
        Amount must increment 100 until 500, then 1000 , 2000 , 3000 ... after 500
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>PAN Number</mat-label>
      <input matInput formControlName="pan" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Aadhaar Number</mat-label>
      <input matInput formControlName="aadhaar" />
    </mat-form-field>

    

    <div class="actions">
       <button
        mat-button
        color="primary"
        type="button"
        (click)="createCustomerAndPrintReceipt()"
      >
        Create & Print Receipt
      </button>

      <button
        mat-button
        color="primary"
        type="button"
        (click)="createCustomer()"
      >
        Create
      </button>
      <button mat-button type="button" routerLink="/updatePrice">Cancel</button>
    </div>
  </form>
</div>
